export type DebugInfo = {
  devtoolsFrontendUrl: string | undefined
}
